module.exports = __webpack_public_path__ + "static/img/ARCHIE-LUDOWYKE.ba1e3aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ARCHIE-LUDOWYKE.jpg
// module id = hxDB
// module chunks = 0